// src/services/tariffService.js
import axios from "axios";
import { BACKEND_URL } from "../utils/envConfig";

const API_URL = `${BACKEND_URL}/tariffs`;

// Tariff Master Management
export const getAllTariffs = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

export const getTariffById = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`);
  return response.data;
};

export const getTariffByType = async (type) => {
  const response = await axios.get(`${API_URL}/type/${type}`);
  return response.data;
};

export const getTariffByOrganization = async (organizationId) => {
  // Prefer organization endpoint: /organizations/{id}/tariff
  try {
    const base = BACKEND_URL;
    const response = await axios.get(`${base}/organizations/${organizationId}/tariff`);
    return response.data;
  } catch (err) {
    // Fallback to legacy tariffs endpoint if available
    try {
      const response = await axios.get(`${API_URL}/organization/${organizationId}`);
      return response.data;
    } catch (e2) {
      // If both fail (e.g., 404), return null so caller can handle gracefully
      return null;
    }
  }
};

export const createTariff = async (tariffData) => {
  const response = await axios.post(API_URL, tariffData);
  return response.data;
};

export const updateTariff = async (id, tariffData) => {
  const response = await axios.put(`${API_URL}/${id}`, tariffData);
  return response.data;
};

export const deleteTariff = async (id) => {
  const response = await axios.delete(`${API_URL}/${id}`);
  return response.data;
};

// Get default hospital tariff (cash)
export const getHospitalTariff = async () => {
  const response = await axios.get(`${API_URL}/hospital/default`);
  return response.data;
};

// Get tariff for specific payment mode and organization
export const getTariffForBilling = async (paymentMode, organizationId = null) => {
  if (paymentMode === 'cash') {
    return await getHospitalTariff();
  }
  if (paymentMode === 'credit') {
    if (!organizationId) return null; // defer until org is selected
    return await getTariffByOrganization(organizationId);
  }
  return null;
};

// Tariff Rate Management
export const getTariffRates = async (tariffId) => {
  const response = await axios.get(`${API_URL}/${tariffId}/rates`);
  return response.data;
};

export const updateTariffRates = async (tariffId, rates) => {
  const response = await axios.put(`${API_URL}/${tariffId}/rates`, rates);
  return response.data;
};

// Calculate bill amount using tariff
export const calculateBillAmount = async (tariffId, services) => {
  const response = await axios.post(`${API_URL}/${tariffId}/calculate`, { services });
  return response.data;
};

export default {
  getAllTariffs,
  getTariffById,
  getTariffByType,
  getTariffByOrganization,
  createTariff,
  updateTariff,
  deleteTariff,
  getHospitalTariff,
  getTariffForBilling,
  getTariffRates,
  updateTariffRates,
  calculateBillAmount
};
